var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.start
        ? [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.currentFrame,
                  expression: "currentFrame",
                  modifiers: { number: true }
                }
              ],
              attrs: { type: "range", min: _vm.start, max: _vm.end },
              domProps: { value: _vm.currentFrame },
              on: {
                __r: function($event) {
                  _vm.currentFrame = _vm._n($event.target.value)
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" Current Frame = " + _vm._s(_vm.currentFrame) + " "),
            _c("br")
          ]
        : _vm._e(),
      _vm._t("default", null, { keyframe: _vm.currentFrame })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }